import React from "react";
import { FadeUp, SlideInFromLeft } from "./AnimationLibrary";

const stepNames = {
	"1": "Welcome",
	"2": "Set Password",
	"3": "Confirmation"
};

export function StepList(props) {
	return (
		<div className="step-list__container">
			<ul className="step-list__steps">
				{Object.keys(stepNames).map((listStep, i) => (
					<SlideInFromLeft key={i} delay={i * 150}>
						<li className={"step-list__step " + (props.step === listStep ? "active" : "")}>
							{stepNames[listStep]}
						</li>
					</SlideInFromLeft>
				))}
			</ul>
		</div>
	);
}

export function SectionTitle(props) {
	return (
		<div className="heading-container hide-on-mobile">
			<FadeUp delay="0">
				<h2 className="main-heading">{stepNames[props.step]}</h2>
				{props.showStepProgress === true ? <StepProgress step={props.step} /> : ""}
			</FadeUp>
		</div>
	);
}

const StepProgress = props => {
	return (
		<span className="subheading">
			Step {props.step} of {Object.keys(stepNames).length}
		</span>
	)
};